import React, { useEffect, lazy,Suspense,useState } from "react";
// import FilmStripCarousel from './FilmStripCarousel'
import NewFilm from "./NewFilm";
import ImmortalDescription from "./ImmortalDescription";
import ImmortalCards from "./ImmortalCards";
// import ImmortalImage from './ImmortalImage'
import img1 from "../../assets/ArabicVinyl/arabicvinyl10.jpg";
import img2 from "../../assets/ArabicVinyl/arabicvinyl13.jpg";
import { RiArrowDownDoubleFill } from "react-icons/ri";
import { useCart } from "../Cart/CartContext";

const CategoryCarouselV2 = lazy(
  () => import("../CategoryCarousel/CategoryCarouselV2"),
);
const Loader = () => <div style={{ height: "350px" }} />



const ImmortalSection = () => {
  const images = [img1, img2, img1, img2, img1];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScrollDown = () => {
    window.scrollBy({
      top: 600,
      behavior: "smooth",
    });
  };

  const {
      // cartItems,
      addToCart,
      // removeItem,
      // increaseQty,
      // decreaseQty
    } = useCart();
    const [cartOpen, setCartOpen] = useState(false);
  return (
    <div
    // className="pb-5"
    // style={{
    //   backgroundImage:
    //     "linear-gradient(180deg, transparent 55%, rgba(0, 0, 0, 0.17) 71%)",
    //   backgroundColor: "transparent",
    // }}
    >
      <NewFilm images={images} intervalMs={3000} />
      <div className="scroll-down-indicator" onClick={handleScrollDown}>
        <div className="scroll-down-circle">
          <RiArrowDownDoubleFill size={30} />
        </div>
        {/* <span>Scroll Down</span> */}
      </div>
      {/* <ImmortalImage/> */}
      <ImmortalDescription />
      <ImmortalCards />
      <Suspense fallback={<Loader />}>
        <CategoryCarouselV2
          id="immortal-section"
          title="Immortal Section"
          immortal={1}
          // product={product}
          //ArabicVinylData={ArabicVinylData}
          onAddToCart={(item, qty = 1, sourceEl = null) => {
            addToCart(item, qty, sourceEl);
            // setCartOpen(true);
          }}
          direction="ltr"
        />
      </Suspense>
    </div>
  );
};

export default ImmortalSection;
